import { useMemo } from 'react';

import { useBoundStore } from '@/store/store';

export function useUser() {
  const user = useBoundStore(state => state.user);
  const jwt = useBoundStore(state => state.jwt);
  const currentOrganizationId = useBoundStore(
    state => state.currentOrganizationId,
  );
  const organization = useMemo(
    () =>
      user?.organizations.find(
        organization => organization.id === currentOrganizationId,
      ),
    [user, currentOrganizationId],
  );

  const logout = useBoundStore(state => state.logout);
  const setUser = useBoundStore(state => state.setUser);
  const setJwt = useBoundStore(state => state.setJwt);
  const setCurrentOrganizationId = useBoundStore(
    state => state.setCurrentOrganizationId,
  );

  return {
    user,
    jwt,
    currentOrganizationId,
    organization,
    logout,
    setUser,
    setJwt,
    setCurrentOrganizationId,
  };
}
